import { render, staticRenderFns } from "./gzh.vue?vue&type=template&id=0ac8f4a1&scoped=true"
import script from "./gzh.vue?vue&type=script&lang=js"
export * from "./gzh.vue?vue&type=script&lang=js"
import style0 from "./gzh.vue?vue&type=style&index=0&id=0ac8f4a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac8f4a1",
  null
  
)

export default component.exports